module.exports = __webpack_public_path__ + "static/media/hotsite-area-reservada.3425b3ae.webp";